import { render, staticRenderFns } from "./SelectDetalleTrimovil.vue?vue&type=template&id=6969f9ca&"
import script from "./SelectDetalleTrimovil.vue?vue&type=script&lang=js&"
export * from "./SelectDetalleTrimovil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports